var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',[_c('BaseContent',{staticClass:"page",attrs:{"title":"Mixes"}},[_c('BaseTabPanel',{staticClass:"tabs",attrs:{"tabs":_vm.loggedIn ? _vm.authTabs : _vm.tabs,"is-underlined":"","is-unpadded":"","address-navigation":""}}),_c(_vm.mainComponent,{tag:"component",staticClass:"component"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }